import { useMutation } from '@tanstack/react-query';
import type { pipeline } from '@/types';
import type { ScmProviderId } from '@/types/scm-provider';
import { scmPost } from './scmClient';

interface RequestBody {
  provider: ScmProviderId;
  body: {
    organization: string;
    project: string;
  };
  requesterToken: {
    patToken: string;
  };
}

export const getPipelineDetails = async ({
  provider,
  body,
  requesterToken,
}: RequestBody): Promise<pipeline[]> => {
  const res: { data?: { workflows?: pipeline[] } } = await scmPost(
    provider,
    '/api/scm/workflows',
    requesterToken.patToken,
    {
      organization: body.organization,
      project: body.project,
      repository: '',
    },
  );
  return res?.data?.workflows ?? [];
};

export const usePipelineDetail = ({ provider, body, requesterToken }: RequestBody) => {
  const res = useMutation({
    mutationFn: () => getPipelineDetails({ provider, body, requesterToken }),
  });

  return {
    pipelineData: res.data,
    pipelinePending: res.isPending,
    pipelineError: res.error,
    pipelineStatus: res.status,
    mutate: res.mutate,
  };
};
